import { useAuth0 } from "@auth0/auth0-react";

import { deleteData, getData, patchData, postData, updateData } from "@/services";

const useApisClient = () => {
    const { getAccessTokenSilently } = useAuth0();

    return {
        delete: async (apiUrl, id, config) => {
            const token = await getAccessTokenSilently();
            return deleteData(apiUrl, id, {
                token,
                ...config,
            });
        },
        get: async (apiUrl, id, params, config) => {
            const token = await getAccessTokenSilently();
            return getData(apiUrl, id, params, {
                token,
                ...config,
            });
        },
        patch: async (apiUrl, id, data, params, config) => {
            const token = await getAccessTokenSilently();
            return patchData(apiUrl, id, data, params, {
                token,
                ...config,
            });
        },
        post: async (apiUrl, id, data, config) => {
            const token = await getAccessTokenSilently();
            return postData(apiUrl, id, data, {
                token,
                ...config,
            });
        },
        update: async (apiUrl, id, data, params, config) => {
            const token = await getAccessTokenSilently();
            return updateData(apiUrl, id, data, params, {
                token,
                ...config,
            });
        },
    };
};

export default useApisClient;
